import { compose, getContext, withState, withHandlers } from "recompose";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";
import { fetchApi } from "core/api/hoc";
import { createLoadingSelector } from "core/helpers";
import { withActions } from "core/redux/hoc";
import * as bookingApi from "modules/booking/api";
import * as hoc from "modules/user/auth/hoc";
import { replaceParams } from "core/utils";
import { candidate } from "routes/paths";
import { push } from "react-router-redux";
import { isOnboardedCandidate } from "modules/user/auth/model";
import * as insidersSelectors from "modules/insiders/selectors";
import * as bookingSelectors from "modules/booking/selectors";
import * as paymentSelectors from "modules/payment/selectors";
import { parse } from "query-string";
import * as paymentApi from "modules/payment/api";
import View from "./View";
import PropTypes from "prop-types";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";

const contextTypes = {
  mixpanel: PropTypes.shape({
    init: PropTypes.func.isRequired,
    track: PropTypes.func.isRequired
  })
};

export default compose(
  hoc.authorized(isOnboardedCandidate),
  withState("promoCode", "setPromoCode", void 0),
  withRouter,
  getContext(contextTypes),
  fetchApi(bookingApi.getBookingDetail, ({ match, location }) => {
    const { bookingId } = parse(location.search);
    return {
      payload: {
        id: bookingId
      },
      sync: true,
      selector: bookingSelectors.getBookingDetailApi
    };
  }),
  fetchApi(paymentApi.getCards, {
    key: "cards",
    selector: paymentSelectors.getCardsApi
  }),
  withActions({
    deleteObjective: ({ location, mixpanel }) => ({ id, label }) => {
      const { bookingId } = parse(location.search);
      mixpanel.track("Sub-Objective deleted", { objective: label });
      fbPixel.fbq("trackCustom", "SubObjectiveDeleted");
      dataLayer.push({
        event: "DeleteSubObjective"
      });
      return bookingApi.deleteSubObjective.request({
        bookingId: bookingId,
        sub_objective: id,
        label
      });
    },
    applyPromoCode: ({ location, match }) => ({ promo_code }) => {
      const { bookingId } = parse(location.search);
      return bookingApi.applyPromoCode.request({
        bookingId,
        promo_code,
        insiderId: match.params.id
      });
    }
  }),
  connect(
    createStructuredSelector({
      booking: bookingSelectors.fetchBookingDetail,
      coupon: bookingSelectors.applyPromoCodeApi,
      isLoading: createLoadingSelector(
        bookingSelectors.getBookingDetailApi,
        paymentSelectors.getCardsApi
      )
    }),
    dispatch => ({
      createCard: type => token =>
        dispatch(
          paymentApi.submitPayment.request({
            body: {
              gateway: "stripe",
              is_default: type === "first",
              token: token.id,
              last_4_digits: token.card.last4,
              expiry_month: token.card.exp_month,
              expiry_year: token.card.exp_year,
              brand: token.card.brand
            },
            type
          })
        )
    })
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/Provider.js